import { getMyBenefitDownloadUrl } from "@benefit-systems/shared/features/mybenefit-app-download";
import { getMobilePlatform } from "@benefit-systems/shared/utils/platform";


const getRedirectData = () => {
  const params = new URLSearchParams(window.location.search);

  if (params.get("redirectToNativeStore") !== "true") {
    return { willRedirectToStore: false, url: null };
  }

  const platform = getMobilePlatform();
  const storeUrl = getMyBenefitDownloadUrl(platform);

  if (storeUrl) {
    return { willRedirectToStore: true, url: storeUrl };
  }

  const url = new URL(window.location.href);
  url.searchParams.delete("redirectToNativeStore");

  return {
    willRedirectToStore: false,
    url: url.toString(),
  };
};

export default getRedirectData;
